import React, { useEffect, useMemo, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import Maps from 'views/Maps';
import MapsCalibration from 'views/MapsCalibration';
import MapsUnits from 'views/Maps Units';
import MapsMeasures from 'views/Maps Measures';
import MapsTracking from 'views/MapsTracking';
import './MapsHub.css';

const TAB_EQUIPMENTS = 'equipments';
const TAB_CALIBRATION = 'calibration';
const TAB_UNITS = 'units';
const TAB_MEASURES = 'measures';
const TAB_TRACKING = 'tracking';

const TAB_DEFS = [
  { id: TAB_EQUIPMENTS, label: 'Equipamentos' },
  { id: TAB_CALIBRATION, label: 'Calibração' },
  { id: TAB_UNITS, label: 'Unidades' },
  { id: TAB_MEASURES, label: 'Medidas' },
  { id: TAB_TRACKING, label: 'Rastreio' }
];

const MAPSUNITS_ONLY_TABS = [TAB_UNITS, TAB_MEASURES, TAB_TRACKING];

const VALID_TABS = TAB_DEFS.map(t => t.id);

const isReadEnabled = permissionEntry => {
  const read = permissionEntry?.read;
  return read === true || read === 'true' || read === 1;
};

const MapsHub = () => {
  const history = useHistory();
  const location = useLocation();
  const [isDark, setIsDark] = useState(() => localStorage.getItem('theme') === 'dark');

  useEffect(() => {
    const onStorage = e => {
      if (e.key === 'theme') {
        setIsDark(e.newValue === 'dark');
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const availableTabs = useMemo(() => {
    const user = JSON.parse(localStorage.getItem('userData') || 'null');
    const canMaps = isReadEnabled(user?.permission?.maps);
    const canMapsUnits = isReadEnabled(user?.permission?.mapsunits);

    // Quem tem maps vê todas as abas
    if (canMaps) {
      return TAB_DEFS;
    }

    // Quem só tem mapsunits vê Unidades e Medidas
    if (canMapsUnits) {
      return TAB_DEFS.filter(tab => MAPSUNITS_ONLY_TABS.includes(tab.id));
    }

    return [];
  }, []);

  const tabFromQuery = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    return VALID_TABS.includes(tab) ? tab : null;
  }, [location.search]);

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (!availableTabs.length) {
      window.location.replace('/home');
      return;
    }

    const nextTab =
      (tabFromQuery && availableTabs.some(t => t.id === tabFromQuery)
        ? tabFromQuery
        : null) ||
      (availableTabs.some(t => t.id === activeTab) ? activeTab : null) ||
      availableTabs[0].id;

    if (nextTab !== activeTab) {
      setActiveTab(nextTab);
    }

    const params = new URLSearchParams(location.search);
    if (params.get('tab') !== nextTab) {
      params.set('tab', nextTab);
      history.replace({ pathname: '/maps', search: `?${params.toString()}` });
    }
  }, [availableTabs, tabFromQuery, activeTab, history, location.search]);

  const handleSelectTab = tabId => {
    if (tabId === activeTab) return;
    setActiveTab(tabId);
    const params = new URLSearchParams(location.search);
    params.set('tab', tabId);
    history.push({ pathname: '/maps', search: `?${params.toString()}` });
  };

  if (!availableTabs.length || !activeTab) {
    return null;
  }

  return (
    <div className={`maps-hub${isDark ? ' maps-hub--dark' : ''}`}>
      <div className="maps-hub__tabs">
        <Nav variant="pills" activeKey={activeTab} onSelect={handleSelectTab}>
          {availableTabs.map(tab => (
            <Nav.Item key={tab.id}>
              <Nav.Link eventKey={tab.id}>{tab.label}</Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>

      <div className="maps-hub__content">
        {activeTab === TAB_EQUIPMENTS && <Maps />}
        {activeTab === TAB_CALIBRATION && <MapsCalibration />}
        {activeTab === TAB_UNITS && <MapsUnits />}
        {activeTab === TAB_MEASURES && <MapsMeasures />}
        {activeTab === TAB_TRACKING && <MapsTracking />}
      </div>
    </div>
  );
};

export default MapsHub;
